import { IconButton, Tooltip } from '@mui/material'
import { styled } from '@mui/material/styles'
import AccountTreeIcon from '@mui/icons-material/AccountTree'
import { ICellRendererParams } from 'ag-grid-community'
import { ProgramOverviewDto } from '../../../../infrastructure/api/programs'
import { intl } from '../../../../i18n'
import { isProgramTransitionVisible } from '../model/programPermission'
import { ProgramGridContext } from './columnDefs'

const Wrapper = styled('div')({
  display: 'flex',
  alignItems: 'center',
})

export const TransitionIconsCellRenderer = (
  params: ICellRendererParams<ProgramOverviewDto>
) => {
  const program = params.data
  if (!program) return null

  const context: ProgramGridContext = params.context
  if (
    !isProgramTransitionVisible(
      program,
      context.currentUserUuid,
      context.isAdmin
    )
  ) {
    return null
  }

  const openManagement = () => {
    window.open(
      `${window.location.origin}/programManagement/${program.code}`,
      '_blank'
    )
  }

  return (
    <Wrapper>
      <Tooltip
        title={intl.formatMessage({
          id: 'programList.list.transition.management',
        })}
      >
        <span>
          <IconButton size="small" onClick={openManagement}>
            <AccountTreeIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
    </Wrapper>
  )
}
